<template>
<div>
  <div id="RewardsTitle">
    <hr>

    <div id="title">
      {{ title }}
    </div>
  </div>
</div>
</template>

<script>

export default {
  props: [ 'title' ]
}
</script>

<style scoped>
  #RewardsTitle {
    position: relative;
    width: 100vw;
    padding: 50px 0px;
  }

  #title {
    position: absolute;
    top: calc(50% - 23px);
    left: calc(50vw - (300px / 2));

    width: 300px;
    background-color: white;

    font-size: var(--text-size-2);
    font-weight: 600;
    text-align: center;
  }

  hr {
    border: none;
    height: 1px;
    color: silver;
    background-color: silver;
  }

  @media (min-width: 960px) { 
    hr {
      width: 60vw;
      position: relative;
      left: 20vw;
    }
  }
</style>
